import { changeLanguage, SideNavAnchor, useScopedSelector } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useDispatch } from 'react-redux';

export interface ChangeLanguageButtonProps { }

const ChangeLanguageButton: FC<ChangeLanguageButtonProps> = () => {
  const language = useScopedSelector<string>('/language.locale')?.substring(0, 2) || 'en';
  const isCurrentLanguageFrench = useMemo(() => language === 'fr', [language]);
  const nextLanguage = useMemo(() => isCurrentLanguageFrench ? 'en' : 'fr', [isCurrentLanguageFrench]);
  const nextLanguageText = useMemo(() => isCurrentLanguageFrench ? 'English' : 'Français', [isCurrentLanguageFrench]);
  const dispatch = useDispatch();

  return (
    <SideNavAnchor onClick={() => dispatch(changeLanguage(nextLanguage))} data-testid="LanguageButton">{nextLanguageText}</SideNavAnchor>
  );
};

export default ChangeLanguageButton;
